import { IS_MOBILE } from '@repo/common-utils';
import { cva } from 'class-variance-authority';
import { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../../libs/utils';

const cardVariant = cva('py-normal-large px-normal-medium rounded-bzc-medium ', {
  variants: {
    outline: {
      true: 'ring-1 ring-neutral-border-high',
      false: ''
    },
    selected: {
      true: 'bg-primary-background-lowest ring-2 ring-primary-border-main',
      false: 'bg-neutral-background-main'
    }
  },
  defaultVariants: {
    outline: false
  }
});

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: ReactNode;
  bg?: string;
  outline?: boolean;
  action?: boolean;
  selected?: boolean;
}

export function Card({ className, children, outline = true, action = false, selected = false, onClick, bg, ...props }: CardProps) {
  const dynamicStyle = bg ? { backgroundColor: bg } : undefined;

  return (
    <div
      className={cn(
        cardVariant({ outline, selected }),
        {
          'active:bg-card-gradient': action && IS_MOBILE,
          'hover:bg-card-gradient hover:cursor-pointer': action && !IS_MOBILE
        },
        className
      )}
      onClick={onClick}
      style={dynamicStyle}
      {...props}
    >
      {children}
    </div>
  );
}

interface CardContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

export function CardContent({ children, className, ...props }: CardContentProps) {
  return (
    <div className={className} {...props}>
      <div>{children}</div>
    </div>
  );
}
